import elementService from "@/common/ElementService";

export default new class FooterContainerToggleService {
    public init(): void {
        for (const toggleButton of document.querySelectorAll<HTMLButtonElement>(".footer-one p button")) {
            toggleButton.addEventListener("click", () => this.toggleContainer(toggleButton));
        }
    }

    private toggleContainer(toggleButton: HTMLButtonElement): void {
        const container = elementService.closest<HTMLDivElement>(toggleButton, ".footer-one");
        const containerContent = elementService.elementQuerySelector<HTMLElement>(container, "ul");

        containerContent.removeEventListener("transitionend", this.handleTransitionEnd as EventListener);

        if (container.classList.contains("active")) {
            container.classList.remove("active");
            containerContent.classList.remove("fade-in");
            containerContent.classList.add("fade-out");
            containerContent.addEventListener("transitionend", this.handleTransitionEnd as EventListener);
        } else {
            container.classList.add("active");
            containerContent.classList.remove("fade-out");
            containerContent.classList.add("fade-in");
            containerContent.style.display = "block";
        }
    }

    private readonly handleTransitionEnd = (event: TransitionEvent): void => {
        const target = event.target as HTMLElement;

        if (target.classList.contains("fade-out")) {
            target.style.display = "none";
        }

        target.removeEventListener("transitionend", this.handleTransitionEnd as EventListener);
    };
}();
